import { EMPTY_TEXT } from '@mitchell/react.component.ux';
import { PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_FAILURE, PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_REQUEST, PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_SUCCESS, PHOTO_CAPTURE_INTELLIGENT_UPDATE_OCR } from '../actions';
import { IntelligentPhotoCapturePhotoPreviewConstants } from '../constants';
export const photoCaptureIntelligentImageDetailOCRReducer = (state, action) => {
    var _a, _b, _c;
    switch (action.type) {
        case PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true });
        case PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_SUCCESS: {
            const { results = [] } = action.payload.photoCaptureImageOCRData;
            let ocrInfo = {
                ocrText: EMPTY_TEXT,
                errorMessage: EMPTY_TEXT
            };
            if ((_b = (_a = results === null || results === void 0 ? void 0 : results[0]) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.code) {
                ocrInfo.errorMessage = IntelligentPhotoCapturePhotoPreviewConstants.OCR_FAILED_MESSAGE;
            }
            else {
                ocrInfo.ocrText = ((_c = results === null || results === void 0 ? void 0 : results[0]) === null || _c === void 0 ? void 0 : _c.text) || EMPTY_TEXT;
            }
            return Object.assign(Object.assign({}, state), { isLoading: false, ocrInfo: Object.assign(Object.assign({}, ocrInfo), { ocrText: ocrInfo.ocrText.toString(), isOCRServiceCallCompleted: true }) });
        }
        case PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_FAILURE: {
            return Object.assign(Object.assign({}, state), { isLoading: false, serviceFailStatus: IntelligentPhotoCapturePhotoPreviewConstants.OCR_FAILED_MESSAGE, ocrInfo: {
                    ocrText: EMPTY_TEXT,
                    errorMessage: IntelligentPhotoCapturePhotoPreviewConstants.OCR_FAILED_MESSAGE,
                    isOCRServiceCallCompleted: true
                } });
        }
        case PHOTO_CAPTURE_INTELLIGENT_UPDATE_OCR: {
            const { ocrInfo = { ocrText: '', errorMessage: '' } } = action.payload;
            return Object.assign(Object.assign({}, state), { ocrInfo });
        }
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureIntelligentImageDetailOCRReducer.js.map